'use client';

import type { AnchorHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';

interface LinkButtonPrimaryProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
}

const LinkButtonPrimary = ({ href, className, children, ...props }: LinkButtonPrimaryProps) => {
  return (
    <a
      href={href}
      className={tw(
        'bg-primary-dark dark:bg-primary-dark hover:bg-primary-dark dark:hover:bg-primary relative z-10 inline-flex items-center justify-center overflow-hidden rounded-xl px-7 py-3.5 font-semibold tracking-wide no-underline shadow-md transition-all duration-300 text-shadow-md/50 *:drop-shadow-md *:drop-shadow-black/70 hover:-translate-y-1 hover:shadow-lg active:-translate-y-px',
        'font-bold text-[#ffffff] text-white', // Keep the working approach with improved weight
        'border-primary dark:border-primary-light border-2', // Add border with original primary color
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export default LinkButtonPrimary;
